// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type CheckboxIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from checkbox.svg
 */
export default function CheckboxIcon(props: CheckboxIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="CheckboxIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M0 2.5A2.5 2.5 0 0 1 2.5 0h11A2.5 2.5 0 0 1 16 2.5v11a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 0 13.5zM2.5 1A1.5 1.5 0 0 0 1 2.5v11A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 13.5 1z"
          clip-rule="evenodd"
        />
      </g>
    </svg>
  );
}
